export default __webpack_public_path__ + "static/media/salon-marketplace.ff664b1d.jpg";